<template>
  <v-card class="control-tooltip">
    <template
      v-slot:title
      v-if="tooltipInfo?.friendlyName || tooltipInfo?.techInfo"
    >
      <span class="text-h5 text-primary">
        {{
          tooltipInfo.friendlyName
            ? tooltipInfo.friendlyName
            : tooltipInfo.techInfo
        }}
      </span>
    </template>
    <v-divider v-if="tooltipInfo?.friendlyName || tooltipInfo?.techInfo" />
    <v-card-text class="bg-aliceBlue">
      <slot></slot>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
defineProps<{
  hasDataIssues?: boolean;
  tooltipInfo?: {
    friendlyName?: string;
    techInfo?: string;
  };
  color?: string;
}>();
</script>
<style lang="scss" scoped>
.control-tooltip {
  padding: 5px 0 0 0;
  opacity: 1 !important;
  background-color: #fff;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
}

.v-alert :deep(.v-alert__border) {
  opacity: 1 !important;
}
</style>
